import React, { forwardRef } from 'react';

const inputStyle = {
    display: 'flex',
    height: '2.5rem',
    width: '100%',
    borderRadius: '0.375rem',
    border: '1px solid #e2e8f0', // slate-200
    backgroundColor: '#ffffff',
    padding: '0.5rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: '#0f172a',
    outline: 'none',
    transition: 'border-color 0.2s'
};

const Input = forwardRef(({ className, type, style, ...props }, ref) => {
    return (
        <input
            type={type}
            className={className} // Keep valid classNames just in case
            style={{ ...inputStyle, ...style }}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = "Input";

export { Input };
